const activeDialogSelector = state => state.admin.partnerSite.active
const activeAddDialogSelector = state => state.admin.partnerSite.activeAdd

export {
  activeDialogSelector,
  activeAddDialogSelector
}
